import React from "react";

export const Hero = ({ moduleNum, eyebrowLabel, italic, normal, accent, description, icon: Icon }) => (
  <section className="relative mb-16 border border-white/10 bg-[#0c0c0c] overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(212,175,55,0.18),transparent_55%),radial-gradient(circle_at_80%_80%,rgba(212,175,55,0.08),transparent_55%)]" />
    <div className="relative p-10 md:p-14">
      <div className="flex items-center gap-3">
        {Icon && <Icon className="h-5 w-5 text-[#D4AF37]" />}
        <span className="text-[11px] uppercase tracking-[0.4em] text-[#D4AF37]">{eyebrowLabel} · {moduleNum}</span>
      </div>
      <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-tight mt-6 max-w-3xl">
        <em className="italic text-[#F5F5DC]">{italic}</em>{normal && <><br />{normal} </>}
        {accent && <span className="text-[#D4AF37]">{accent}</span>}.
      </h1>
      {description && <p className="mt-6 max-w-2xl text-[#A1A1AA] leading-relaxed">{description}</p>}
    </div>
  </section>
);

export const Section = ({ eyebrow, title, index, children }) => (
  <section className="mb-20">
    <div className="flex items-baseline gap-6 mb-8">
      <span className="font-serif text-xl text-[#D4AF37] tabular-nums">{index}</span>
      <div>
        <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37]">{eyebrow}</div>
        <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-light mt-2 leading-tight">{title}</h2>
      </div>
    </div>
    <div className="text-[#C4C4C7] leading-relaxed space-y-4 pl-0 md:pl-10">{children}</div>
  </section>
);

export const Sub = ({ title, children }) => (
  <div className="mt-12">
    <h3 className="font-serif text-xl md:text-2xl text-white mb-4 flex items-center gap-3">
      <span className="h-px w-8 bg-[#D4AF37]" /> {title}
    </h3>
    <div className="space-y-3 text-[#C4C4C7] leading-relaxed">{children}</div>
  </div>
);

export const Callout = ({ icon: Icon, title, children }) => (
  <div className="mt-8 border-l-2 border-[#D4AF37] bg-[#141414] p-6 md:p-7">
    <div className="flex items-center gap-3">
      {Icon && <Icon className="h-4 w-4 text-[#D4AF37]" />}
      <span className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">{title}</span>
    </div>
    <div className="mt-3 text-[#E4E4E7] leading-relaxed text-sm space-y-3">{children}</div>
  </div>
);

export const Quote = ({ text }) => (
  <div className="border-l-2 border-[#D4AF37] pl-5 py-2 my-6">
    <p className="font-serif text-xl text-[#F5F5DC] italic leading-snug">« {text} »</p>
  </div>
);

export const NumberedItem = ({ n, title, children }) => (
  <div className="grid grid-cols-[60px_1fr] gap-4 border-l border-[#D4AF37]/30 pl-5 py-2">
    <div className="font-serif text-xl text-[#D4AF37] tabular-nums">{n}</div>
    <div>
      {title && <h4 className="font-serif text-base text-white mb-2">{title}</h4>}
      <div className="text-sm text-[#A1A1AA] leading-relaxed space-y-2">{children}</div>
    </div>
  </div>
);

export const Bold = ({ children }) => <strong className="text-white">{children}</strong>;

export const Em = ({ children }) => <em className="text-[#F5F5DC] not-italic font-medium">{children}</em>;
